import { CoAppTextButton, CoAppTextDestructiveButton } from "../../styled/global.styled";

export default function CoAppIconTextButton({
	icon,
	onClick,
	text,
	isDestructive = false,
	disabled = false,
}) {
	if (isDestructive) {
		return (
			<CoAppTextDestructiveButton onClick={onClick} disabled={disabled}>
				{icon}
				{text}
			</CoAppTextDestructiveButton>
		);
	}
	return (
		<CoAppTextButton onClick={onClick} ismodal="false" disabled={disabled}>
			{icon}
			{text}
		</CoAppTextButton>
	);
}